import styled from 'styled-components';

export const UiDroppable = styled.div`
  width:100%;
  height: 100%;
  display:flex;
  flex-wrap:wrap;
  align-items:flex-start;
`;